__turbopack_context__.v({
  "richTextContainer": "RichText-module-scss-module__AMWwVW__richTextContainer",
});
